/**
 * 创建请求实例
 * @returns
 */
const createXHR = function () {
  if (window.XMLHttpRequest) {
    return new XMLHttpRequest()
  } else {
    return new ActiveXObject('MicroSoft.XMLHTTP')
  }
}

/**
 * 同步配置
 * @param {*} url
 * @param {*} callback
 */
const syncConfig = function (url, callback) {
  const xhr = createXHR()
  xhr.onreadystatechange = function () {
    // 如果不用等于4判断一下，这个函数会执行四五次，也只有等于4的时候才是真的成功
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        callback(xhr.responseText)
      } else {
        console.log('获取数据错误,错误代码：' + xhr.status + '错误信息：' + xhr.statusText)
      }
    }
  }
  xhr.open('get', url, false)
  xhr.send(null)
}

export default syncConfig



// WEBPACK FOOTER //
// ./src/tools/syncConfig.js